<template>
  <div>
    <el-row type="flex" align="middle">
      <el-select
        v-model="inputValue"
        placeholder="Kolor"
        class="margin-right-15"
      >
        <el-option
          v-for="color in colors"
          :key="color.value"
          :label="color.label"
          :value="color.value"
        >
          <span class="color-box" :style="{ backgroundColor: color.value }" />
          <span class="color-name">{{ color.label }}</span>
        </el-option>
      </el-select>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ['value'],
  mounted() {
    this.fetchData()
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    colors() {
      return this.$store.state.colors
    }
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchColors')
    }
  }
}
</script>
<style scoped>
.color-box {
  width: 12px;
  height: 12px;
  display: inline-block;
  vertical-align: middle;
}
.color-name {
  margin-left: 8px;
  display: inline-block;
  vertical-align: middle;
}
</style>
